<template>
  <div class="cf-flex cf-flex--column cf-flex--gap-16 cf-padding-y-16 cf-text-align-center">
    <Teleport
      defer
      to="#portal-modal-header-target"
    >
      {{ modalTitle }}
    </Teleport>

    <template v-if="isLoyaltyCheckinEnabled">
      <h2 class="cf-title cf-title--2">
        {{ content.ScanToCheckInModal.metadata.learnMoreModalTitle }}
      </h2>

      <p class="cf-subtitle cf-subtitle--2">
        {{ content.ScanToCheckInModal.metadata.learnMoreModalDescription }}
      </p>
    </template>

    <template v-if="isLoyaltyReceiptScanningEnabled">
      <h2 class="cf-title cf-title--2">
        {{ content.ScanToEarnModal.metadata.learnMoreModalTitle }}
      </h2>

      <p class="cf-subtitle cf-subtitle--2">
        {{ content.ScanToEarnModal.metadata.learnMoreModalDescription }}
      </p>
    </template>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'ScanLearnMoreModal',

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('merchant', ['merchant']),

      isLoyaltyCheckinEnabled() {
        return this.merchant.options.loyaltyOptions.loyaltyCheckInEnabled;
      },

      isLoyaltyReceiptScanningEnabled() {
        return this.merchant.options.loyaltyOptions.loyaltyReceiptScanningEnabled;
      },

      modalTitle() {
        if (this.isLoyaltyCheckinEnabled && this.isLoyaltyReceiptScanningEnabled) return this.content.ScanToCheckInAndEarnModal.metadata.learnMore;

        if (this.isLoyaltyReceiptScanningEnabled) return this.content.ScanToEarnModal.metadata.learnMore;

        if (this.isLoyaltyCheckinEnabled) return this.content.ScanToCheckInModal.metadata.learnMore;

        return '';
      }
    }
  };
</script>
